import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=3073fd72&scoped=true"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"
import style0 from "./profile.vue?vue&type=style&index=0&id=3073fd72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073fd72",
  null
  
)

export default component.exports